import { ref } from 'vue'
import axios from 'axios'
import { showToast } from 'vant'
import { loading } from '@/utils/loading'
import { useAuthStore } from '@/stores/login'
import router from '@/router'
import { isApp, skipLoginScreen } from '@/utils/client'
import i18n from '@/locales'
import { isTudoApp, closeWebview } from '@/utils/tudo'
import { isOutFieldApp, outFieldCloseWebview } from '@/utils/outfield'
import { branchManagerCloseWebview, isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { isWisdomRabbitApp, wisdomRabbitCloseWebview } from '@/utils/sandsTalkSmartRabbit'

const instance = axios.create()

instance.defaults.baseURL = process.env.VUE_APP_API_URL
instance.defaults.withCredentials = false
instance.defaults.timeout = 30000

const count = ref(0)
let timmer: number = -1

function hideLoading() {
  timmer = setTimeout(() => {
    if (count.value === 0) {
      loading.hide()
    }
  }, 200)
}

function setRequestCount() {
  if (count.value > 0) {
    count.value--
  } else {
    count.value = 0
  }
  hideLoading()
}

instance.interceptors.request.use((config) => {
  const lang = localStorage.getItem('lang')
  const getTenantId = localStorage.getItem('sandsTalkTenantId')
  const { getAccessToken } = useAuthStore()
  if (config.loadingShow !== '0') {
    // console.log('showLoading')
    clearTimeout(timmer)
    loading.show()
    count.value++
  }

  config.headers.Accept = 'application/json'
  if (!config.headers.Authorization) {
    if (getAccessToken) {
      config.headers.Authorization = `Bearer ${getAccessToken}`
    } else {
      const getSandsTalkToken = localStorage.getItem('sandsTalkToken')
      config.headers.Authorization = `Bearer ${getSandsTalkToken}`
    }
  }

  if (getTenantId) {
    config.headers['tenant-id'] = getTenantId
  }

  if (lang) {
    config.headers['Accept-Language'] = lang
  } else {
    config.headers['Accept-Language'] = 'zh-cn'
  }

  config.headers['Common-Platform'] = 'H5'
  // 获取当前时区
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  // 添加请求头参数
  config.headers.timezone = timezone

  return config
})

const loginExpirseCodeArr = [14100, 14280]
const noNoticeCodeArr = [1, 14100, 14280, 14200, 0, 4001508, 20100]
let timer: number | null = null
instance.interceptors.response.use(
  async (res) => {
    if (res.config.loadingShow !== '0') {
      setRequestCount()
    }
    const { code, msg } = res.data

    if (noNoticeCodeArr.indexOf(code) === -1 && res.config.toastShow !== '0') {
      showToast(msg)
    }
    if (loginExpirseCodeArr.indexOf(code) > -1 && !res.config.unLogin) {
      if (isApp) {
        skipLoginScreen()
      } else if (isTudoApp) {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          closeWebview()
        }, 1000)
      } else if (isOutFieldApp) {
        // 外场 请求退出
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          outFieldCloseWebview()
        }, 1000)
      } else if (isBranchManagerApp) {
        // 网点管家 请求退出
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          branchManagerCloseWebview()
        }, 1000)
      } else if (isWisdomRabbitApp) {
        // 智兔App
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          wisdomRabbitCloseWebview()
        }, 1000)
      } else {
        const authStore = useAuthStore()
        const { setUserId } = authStore
        setUserId('')
        const path = location.href.split('#')[1]
        if (path.indexOf('/enterpriseLogin') === -1) {
          // localStorage.removeItem("sandsTalkToken")
          router.replace('/enterpriseLogin?redirect=' + encodeURIComponent(encodeURIComponent(path)))
        } else {
          // router.replace('/login')
        }
      }
    }

    return Promise.resolve(res.data || {})
  },
  (error) => {
    // ERR_NETWORK  ECONNABORTED
    if (error.config.loadingShow !== '0') {
      count.value = 0
      hideLoading()
    }

    if (error.config.toastShow !== '0') {
      showToast(i18n.global.t('app_network_error'))
    }

    return Promise.resolve(error || {})
  }
)

export default instance
